//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Detsky',
  data () {
    return {
      defaultJson: {
        'More than 5 Prem. Vent. Cont.': '超过 5 次室性期前收缩',
        'poorMedicalStatusLabel': `符合以下任意一项：
        • PO₂ < 60 mmHg（8 kPa）
        • PCO₂ > 50 mmHg（6.7 kPa）
        • K < 3 mEq/L
        • HCO₃ < 20 mEq/L
        • BUN > 50 mg/dL（尿素 > 18 mmol/L）
        • 肌酐 > 3 mg/dL（260 µmol/L）
        • SGOT（AST）升高
        • 慢性肝病
        • 非心脏原因所致的卧床不起`,
        'Class III': 'III 级（高危）',
        'Angina Scale': '心绞痛分级',
        '≤ 6 mth': '≤ 6 个月',
        'Pulmonary Edema': '肺水肿',
        'Emergency Surgery': '急诊手术',
        'Unstable Angina (< 6 months)': '不稳定型心绞痛（<  6 个月）',
        'Within 1 week': '一周内',
        'Non sinus rythm (or APBs)': '非窦性心律（或房性早搏）',
        '≤ 1 wk': '≤ 1 周',
        'Poor General Medical Status': '一般健康状况差',
        'Class II': 'II 级（中危）',
        'Class I': 'I 级（低危）',
        'Critical aortic stenosis': '严重的主动脉狭窄',
        '> 6 mth': '> 6 个月',
        'Age': '年龄',
        'More than 6 months': '超过 6 个月',
        'Myocardial Infarction': '心肌梗死',
        'Ever': '曾有',
        'Never': '从不',
        'Within 6 months': '6 个月内'
      },
      form: {
        age: '',
        ccasStage: '',
        pulmonaryEdema: '',
        myoInfaction: '',
        unstableAngina: '0',
        aoStenosis: '0',
        nonSinus: '0',
        pVC: '0',
        emergencySx: '0',
        poorMedicalStatus: '0'
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '从不'},
        {value: '10', name: '一周内'},
        {value: '5', name: '曾有'}
      ],
      dataList2: [
        {value: '0', name: '从不'},
        {value: '10', name: '6个月内'},
        {value: '5', name: '超过6个月'}
      ],
      logit: '...'
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        self.logit = '...'
        return '...'
      } else {
        console.log(form)
        let result = (form.age > 70 ? 5 : 0) +
                      form.pulmonaryEdema +
                      form.myoInfaction +
                      (form.unstableAngina ? 10 : 0) +
                      (form.aoStenosis ? 20 : 0) +
                      (form.nonSinus ? 5 : 0) +
                      (form.pVC ? 5 : 0) +
                      (form.emergencySx ? 10 : 0) +
                      (form.poorMedicalStatus ? 5 : 0) +
                      (form.ccasStage ? (form.ccasStage == 3 ? 10 : (form.ccasStage == 4 ? 20 : 0)) : 0)
        if (result < 15) {
          self.logit = self.defaultJson['Class I']
        } else if (result < 30) {
          self.logit = self.defaultJson['Class II']
        } else {
          self.logit = self.defaultJson['Class III']
        }
        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/Detsky.vue